import { EmptyData, NavMenuError } from 'shared/ui';
import { SectionMenu } from 'shared/ui/section-menu';
import { CPO_ROUTES } from 'shared/consts/routes/cpo';

import { SECTION } from 'entities/navigation';
import { useGetCposQuery } from 'entities/cpo';
import { AddButton } from './add-button';

const { label, path } = SECTION['cpos'];

export function ConnectedCposMenu() {
  const { data, isFetching, error } = useGetCposQuery();

  if (data && data.statusCode !== 0) {
    return <NavMenuError text={data.statusDescription} />;
  }

  if (error) {
    return <NavMenuError />;
  }

  if (!isFetching && !data) {
    return <EmptyData />;
  }

  const items = data?.cpoList || [];

  return (
    <SectionMenu
      loading={isFetching}
      items={items}
      menuKey={path}
      absolutePath={CPO_ROUTES.CPOS}
      label={label}
      addButton={<AddButton />}
    />
  );
}
